import { render } from "./Favourite.vue?vue&type=template&id=442fee71&scoped=true"
import script from "./Favourite.vue?vue&type=script&lang=js"
export * from "./Favourite.vue?vue&type=script&lang=js"

import "./Favourite.vue?vue&type=style&index=0&id=442fee71&lang=scss&scoped=true"

import exportComponent from "D:\\programmazione\\pronails\\MemsionPrivato\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-442fee71"]])

export default __exports__